import React, { useEffect, useState } from "react";
import { Card, CardBody, Col } from "react-bootstrap";
import { FreeQualificationsService } from "./service";
import { ErrorToast, SuccessToast } from "../../shared/toasters/toasters";
import DeleteModal from "../../Common/DeleteModal";
import { useTranslation } from "react-i18next";

const FreeQualificationsList: React.FC = () => {
  const { t } = useTranslation();
  const [list, setList] = useState<string[]>([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [qualificationToDelete, setQualificationToDelete] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      const response = await FreeQualificationsService.getAll();
      setList(response);
    } catch (error) {
      ErrorToast(error);
    }
  };

  const handleApproveClick = async (name: string) => {
    try {
      await FreeQualificationsService.approve(name); // Call the approve API
      SuccessToast(t("freeQualification.successApprove"));
      fetchData(); // Refresh the list after approval
    } catch (error) {
      ErrorToast(error);
    }
  };

  const handleDeleteClick = (name: string) => {
    setQualificationToDelete(name);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (qualificationToDelete) {
      try {
        await FreeQualificationsService.delete(qualificationToDelete);
        SuccessToast(t("freeQualification.successDelete"));
        setShowDeleteModal(false);
        setQualificationToDelete(null);
        fetchData();
      } catch (error) {
        ErrorToast(error);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <Col>
        <Card>
          <CardBody className="card-body">
            <div className="table-responsive">
              <table className="table table-hover sticky-actions">
                <thead>
                  <tr>
                    <th>{t("freeQualification.name")}</th>
                    <th className="text-end sticky-col">{t("freeQualification.actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {list.map((item, index) => (
                    <tr key={index}>
                      <td className="wrap-col">{item}</td>
                      <td className="text-end text-nowrap sticky-col">
                        <button
                          className="btn btn-success btn-sm me-2"
                          onClick={() => handleApproveClick(item)} // Handle approve action
                        >
                          {t("freeQualification.approve")}
                        </button>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDeleteClick(item)}
                        >
                          {t("freeQualification.delete")}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      </Col>

      <DeleteModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleDeleteId={handleDeleteConfirm}
        name={qualificationToDelete || ""}
      />
    </React.Fragment>
  );
};

export default FreeQualificationsList;